<template>
  <v-responsive>
    <dashboard-new
      :level-user-percentage="levelUserPercentage.toFixed(1)"
      :showAdvHeader="validateAds()"
    >
      <template v-slot:header>
        <toolbar-core />
      </template>
      <template v-slot:body>
        <div
          class="ml-10 classContainerBodySlot"
          style="width: calc(100vw - 591px);"
        >
          <div class="containerTabs containerHeaderCourse">
            <div class="containerHeaderCourseContent">
              <div class="containerHeaderCourseText">
                <h1
                  style="text-align: left;
                  font: normal normal 600 24px/40px Poppins;
                  letter-spacing: 0px;
                  color: #101820;
                  margin: 0;"
                >
                  Curso
                </h1>
                <p
                  style="text-align: left;
                  font: normal normal 300 17px/40px Poppins;
                  letter-spacing: 0px;
                  color: #101820;
                  margin: 0;"
                >
                  Panel / Contenido de Curso
                </p>
              </div>
              <div class="containerBtnsList" v-if="courseCertificateEnabled || coursesBadgesEnabled">
                <button 
                  v-if="courseCertificateEnabled"
                  class="containerBtn--seeRigthNow"
                  :disabled="!certificateUrl"
                  @click="HandlerOpenCertificate"
                >
                  <v-icon class="mr-2" color="white">mdi-certificate</v-icon>
                  <span>Ver Certificado</span>
                </button>
                <button 
                  v-if="coursesBadgesEnabled"
                  class="containerBtn--seeRigthNow ml-2"
                  :disabled="!badgeUrl"
                  @click="HandlerOpenBadge"
                >
                  <v-icon class="mr-2" color="white">mdi-medal</v-icon>
                  <span>Ver Insignia</span>
                </button>
              </div>
            </div>
          </div>
          <section class="flexDefault3">
            <section class="flexDefault2">
            <div class="container-new-pill" style=" display: none; ">
                <div class="flexDefault">
                <div class="container-new-text--new">
                    <span class="text-new-custom">NUEVO</span>
                </div>
                <span class="text--5min">5m. video</span>
                </div>
                <span class="container-new-pill_text-title"
                >Ejemplo de Título de Video para la plataforma</span
                >
                <span class="container-new-pill_text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                id elit molestie, vulputate...
                </span>
                <div class="d-flex mt-4">
                <button class="btn-seeRigthNow">
                    <v-icon color="white">mdi-play</v-icon>
                    <span>Ver ahora</span>
                </button>
                <div class="ml-3 roundHeartIconWraper">
                    <v-icon color="white">mdi-heart-outline</v-icon>
                </div>
                </div>
            </div>
            <div class="containerTabs">
                <div class="containerTitleAndButtonsList">
                    <div class="containerTitleAndLoader">
                        <div class="containerTitleList">
                            <span class="subtitleList--text">CD: {{ learnerCourse.course ? learnerCourse.course.code : 'N/A' }}</span>
                            <span class="titleList--text">{{ learnerCourse.course ? learnerCourse.course.name : "Titulo no definido" }}</span>
                        </div>
                    </div>
                    <div class="containerPathGone--loader">
                        <div class="containerPathGone--loader--titles">
                            <span class="containerPathGone--loader--titles--yourPath">Progreso {{ learnerCourse.current_progress }}%</span>
                        </div>
                        <loader-unicolor :percentage="learnerCourse.current_progress" />
                    </div>
                </div>
                <v-divider class="divider-mobile-only" style="margin-top: 1rem;" />


                <div v-if="learnerCourse.current_progress != '100.00'">
                    <v-tabs v-model="tab">
                      <v-tab>
                          <span class="pillsPendingTitle" style="text-transform: capitalize;margin-right: 10px;">Pendientes</span> ({{ content_level_data.length }})
                      </v-tab>
                  
                      <v-tab>
                          <span class="pillsPendingTitle" style="text-transform: capitalize;margin-right: 10px;"> Completadas </span>  ({{ content_level_data_complete.length }})
                      </v-tab>

                      <v-tab>
                          <span class="pillsPendingTitle" style="text-transform: capitalize;margin-right: 10px;">Anuncios</span> ({{ appointments.length }})
                      </v-tab>
                    </v-tabs>
                    <v-divider style="margin-top: 1rem;" />
                    <div v-if="tab === 0" style="margin-top: 1rem;">
                        <section
                          v-for="section in pendingContentByModule"
                          :key="`pending-${section.id}`"
                          class="course-module-section"
                        >
                          <h2 class="course-module-section__title">{{ section.name }}</h2>
                          <div
                            v-for="(item, index) in section.contents"
                            :key="item.id || `pending-${section.id}-${index}`"
                          >
                            <card-list-v2
                              :hidden-fav="true"
                              :data="item"
                              :icon="switchIcon(item)"
                              :index="index"
                            ></card-list-v2>
                          </div>
                        </section>
                    </div>
                    <div v-if="tab === 1" style="margin-top: 1rem;">
                      

                        <div v-if="content_level_data_complete.length === 0">
                            <p>No hay contenido visto.</p>
                        </div>
                        <div v-else>
                            <section
                              v-for="section in completedContentByModule"
                              :key="`completed-${section.id}`"
                              class="course-module-section"
                            >
                              <h2 class="course-module-section__title">{{ section.name }}</h2>
                              <div
                                v-for="(item, index) in section.contents"
                                :key="item.id || `completed-${section.id}-${index}`"
                              >
                                <card-list-v2
                                  :hidden-fav="true"
                                  :data="item"
                                  :icon="switchIcon(item)"
                                >
                                </card-list-v2>
                              </div>
                            </section>
                            
                        </div>
                    </div>
                    <div v-if="tab === 2" style="margin-top: 1rem;">
                        <div v-if="isLoadingAppointments" class="text-center py-4">
                            <v-progress-circular
                            indeterminate
                            color="primary"
                            class="mr-2"
                            ></v-progress-circular>
                            <span class="loading-text">Cargando anuncios...</span>
                        </div>
                        <div v-else-if="appointments.length === 0">
                            <p>Sin anuncios disponibles en este momento.</p>
                        </div>
                        <div v-else>
                            <div v-for="(appointment, index) in appointments" :key="'app-'+index">
                            <appointment-card
                                :data="appointment"
                                class="mb-4"
                            ></appointment-card>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else>
                  <v-tabs v-model="tab">
                      <v-tab>
                          <span class="pillsPendingTitle" style="text-transform: capitalize;margin-right: 10px;"> Completadas </span>  ({{ content_level_data_complete.length }})
                      </v-tab>

                       <v-tab>
                          <span class="pillsPendingTitle" style="text-transform: capitalize;margin-right: 10px;">Anuncios</span> ({{ appointments.length }})
                      </v-tab>

                     
                    </v-tabs>
                    <v-divider style="margin-top: 1rem;" />
                    
                     <div v-if="tab === 0" style="margin-top: 1rem;" >
                        <div v-if="isLoadingContentComplete" class="text-center py-4">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                                class="mr-2"
                            ></v-progress-circular>
                            <span class="loading-text">Cargando contenido...</span>
                        </div>
                        <div v-else-if="content_level_data_complete.length === 0">
                            <p>No hay contenido visto.</p>
                        </div>
                        <div v-else>
                            <section
                              v-for="section in completedContentByModule"
                              :key="`completed-full-${section.id}`"
                              class="course-module-section"
                            >
                              <h2 class="course-module-section__title">{{ section.name }}</h2>
                              <div
                                v-for="(item, index) in section.contents"
                                :key="item.id || `completed-full-${section.id}-${index}`"
                              >
                                <card-list-v2
                                  :favorite-default="item.favorite != null"
                                  :data="item"
                                  :icon="switchIcon(item)"
                                >
                                </card-list-v2>
                              </div>
                            </section>
                        </div>
                    </div>
                    <div v-if="tab === 1" style="margin-top: 1rem;">
                        <div v-if="isLoadingAppointments" class="text-center py-4">
                            <v-progress-circular
                            indeterminate
                            color="primary"
                            class="mr-2"
                            ></v-progress-circular>
                            <span class="loading-text">Cargando anuncios...</span>
                        </div>
                        <div v-else-if="appointments.length === 0">
                            <p>Sin anuncios disponibles en este momento.</p>
                        </div>
                        <div v-else>
                            <div v-for="(appointment, index) in appointments" :key="'app-'+index">
                            <appointment-card
                                :data="appointment"
                                class="mb-4"
                            ></appointment-card>
                            </div>
                        </div>
                    </div>

                </div>

                

                
            </div>
            </section>
          </section>
        </div>

      </template>
    </dashboard-new>
  </v-responsive>
</template>

<script>
import moment from "moment";
import Notification from "../Utils/notification";
import ToolbarCore from "../core/Toolbar";
import CardList from "./Components/CardList";
import Dashboard from "../Dashboard.vue";
import CardListV2 from "./Components/CardListV2.vue";
import AppointmentCard from "./Components/AppointmentCard.vue";
import LoaderUnicolor from "../Dashboard/LoaderUniColorNew.vue";


export default {
  components: {
    "toolbar-core": ToolbarCore,
    // eslint-disable-next-line vue/no-unused-components
    "card-list-component": CardList,
    "dashboard-new": Dashboard,
    "card-list-v2": CardListV2,
    "appointment-card": AppointmentCard,
     "loader-unicolor": LoaderUnicolor,
  },
  data() {
    return {
      modules: [],
      moduleUser: [],
      moduleUserPercentage: 0,
      levelUserPercentage: 0,
      plans: "",
      plans_date: "",
      expiredSubscription: false,
      subscriptionSoontoExpire: false,
      basic: [],
      intermediate: [],
      advanced: [],
      userLevel: "",
      content_level_data: [],
      appointments: [],
      isLoadingAppointments: true,
      content_level_data_complete: [],
      tab: 0,
      module_id: "",
      schedule_id: "",
      learnerCourse: {},
      isLoadingContentComplete: true,
      courseCertificateEnabled: 0,
      coursesBadgesEnabled: 0
    };
  },

  filters: {
    nameTilde(value) {
      return value == "BASICO" ? "BÁSICO" : value;
    },
  },

  created() {
    this.checkSubscriptionDate();
    this.HandlerGetAuthUser();
    this.HandlerGetModules();
    this.HandlerGetNotifications();
  },

   async mounted() {
    this.module_id = this.$route.query.module_id;
    this.schedule_id = this.$route.query.schedule_id;
  },

  computed: {
    getAuthUser() {
      return this.$store.getters["auth/AUTH_USER"];
    },
    getPlansUser() {
      return this.$store.getters["auth/PLANS"];
    },
    certificateUrl() {
      if (!this.learnerCourse.certificates || !Array.isArray(this.learnerCourse.certificates)) {
        return null;
      }
      
      const certificate = this.learnerCourse.certificates.find(cert => cert.type === "certificate");
      
      if (!certificate) {
        return null;
      }
      
      return certificate.public_url || certificate.file_url || null;
    },
    badgeUrl() {
      if (!this.learnerCourse.certificates || !Array.isArray(this.learnerCourse.certificates)) {
        return null;
      }
      
      const badge = this.learnerCourse.certificates.find(cert => cert.type === "badge");
      
      if (!badge) {
        return null;
      }
      
      return badge.public_url || badge.file_url || null;
    },
    pendingContentByModule() {
      return this.groupContentByModule(this.content_level_data);
    },
    completedContentByModule() {
      return this.groupContentByModule(this.content_level_data_complete);
    },
  },

  watch: {
    tab(newValue) {
      if (newValue === 2) {
       // this.HandlerGetListAppointments();
      }
    }
  },

  methods: {
    validateAds() {
      console.log("gets:");
      // console.log("gets:", this.getAuthUser);
      // eslint-disable-next-line no-unreachable
      if (this.getAuthUser.company.length > 0) return false;
      if (this.getAuthUser.plans.length == 0 || this.getPlansUser == undefined)
        return true;
      if (
        this.getAuthUser.plans &&
        this.getAuthUser.plans.length > 0 &&
        this.getPlansUser !== undefined &&
        !this.subscriptionSoontoExpire &&
        !this.expiredSubscription &&
        !this.getAuthUser.company.length
      )
        return `Tu Subscription vence el: ${this.getPlansUser.pivot.due_date}`;
      if (this.expiredSubscription && !this.getAuthUser.company.length)
        return "Renueva tu suscripción";
      if (this.subscriptionSoontoExpire) return "Tu suscripción vence MAÑANA";

      return this.getAuthUser.plans.length === 0 ? true : false;
    },
    switchIcon(data) {
      // const dictionary ={
      //   imagen:'mdi-'
      // }
      console.log("switch", data);
      return "mdi-play";
    },
    checkSubscriptionDate() {
      if (this.getPlansUser) {
        const expiredSubscription = moment(
          this.getPlansUser.pivot.due_date
        ).diff(moment(), "days");

        this.subscriptionSoontoExpire = expiredSubscription == 1 ? true : false;
        this.expiredSubscription = expiredSubscription < 1 ? true : false;
      }
    },
    HandlerRouter(router) {
      this.$router.push({ name: router });
    },
    groupContentByModule(contents) {
      const sections = [];
      const sectionsById = new Map();

      (contents || []).forEach((item) => {
        const moduleId = this.contentModuleId(item);
        if (!sectionsById.has(moduleId)) {
          const section = {
            id: moduleId,
            name: this.contentModuleName(item),
            contents: [],
          };
          sectionsById.set(moduleId, section);
          sections.push(section);
        }

        sectionsById.get(moduleId).contents.push(item);
      });

      return sections;
    },
    contentModuleId(item) {
      return String(
        item.module_id ||
          item.module?.id ||
          item.content_level_module_id ||
          item.content_level_module?.module_id ||
          this.module_id ||
          'current-module'
      );
    },
    contentModuleName(item) {
      return (
        item.module?.name ||
        item.module_name ||
        item.content_level_module?.module?.name ||
        item.content_level_module?.name ||
        this.learnerCourse.course?.name ||
        'Modulo'
      );
    },

    async HandlerGetModules() {
      try {
       
        const response = await this.$store.dispatch("profile/LIST_MODULES");
        this.modules = response.data.data;
        this.moduleUser = this.getAuthUser.modules;
        await this.HandlerGetCourse();
        this.NewHandlerGetListDataMyWay()
        // this.HandlerGetListDataMyWay(this.getAuthUser.level);
        // this.HandlerGetContentsComplete();
        
        this.NewHandlerGetContentsComplete();
        this.HandlerGetListAppointments();

      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        } else {
          this.$snotify.error(error.response.data.message, "Error!");
        }
      }
    },

     async HandlerGetCourse() {
      try {
        const request = { module_id: this.module_id, schedule_id: this.schedule_id};
        const response = await this.$store.dispatch(
          "profile/GET_MODULE",
          request
        );

        this.learnerCourse = response.data.data;
      } catch (error) {

        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
          this.$snotify.error(error.response.data.message, "Error!");
        }  else if (error.response?.status == 410) {
          // Contenido expirado - redirigir al perfil
          this.$snotify.error(
            error.response.data.message || " Este curso ha expirado y ya no está disponible para acceso.",
            "Acceso Expirado"
          );
          this.$router.push('/profile');
          return; // Salir temprano para evitar que se ejecute el finally
        } 
        
      } finally {
        this.isLoadingAppointments = false;
      }
    },



    async HandlerGetListAppointments() {
      try {
        this.isLoadingAppointments = true;
        const request = { course_id: this.module_id, schedule_id: this.schedule_id };
        const response = await this.$store.dispatch(
          "profile/LIST_APPOINTMENTS",
          request
        );

        this.appointments = response.data.data.data;
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      } finally {
        this.isLoadingAppointments = false;
      }
    },

    

    async NewHandlerGetContentsComplete() {
      try {
        this.isLoadingContentComplete = true;
        const request = { module_id: this.module_id, schedule_id: this.schedule_id};
        const response = await this.$store.dispatch(
          "profile/LIST_CONTENT_COMPLETE",
          request
        );

        this.content_level_data_complete = response.data.data;
        
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      } finally {
        this.isLoadingContentComplete = false;
      }
    },

    async HandlerGetContentsComplete() {
      try {
        const response = await this.$store.dispatch(
          "profile/LIST_CONTENT_WATCHED_CONTENT"
        );

        const content = response.data.data;

        if (content.basico != null || content.basico != undefined) {
          this.content_level_data_complete = content.basico;
        }
        
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      }
    },

    async NewHandlerGetListDataMyWay() {
      try {

         const request = { module_id: this.module_id, schedule_id: this.schedule_id};
        const response = await this.$store.dispatch(
          "profile/LIST_CONTENT_PENDING_CONTENT_BY_MODULE",
          request
        );
        this.content_level_data = response.data.data;

      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      }
    },
    
    async HandlerGetListDataMyWay(userLevel) {
      try {

        
        const response = await this.$store.dispatch(
          "profile/LIST_CONTENT_PENDING_CONTENT"
        );


        const content = response.data.data;

        if (content.basico != null || content.basico != undefined) {
          this.basic = content.basico;
        }
        if (content.intermedio != null || content.intermedio != undefined) {
          this.intermediate = content.intermedio;
        }
        if (content.avanzado != null || content.avanzado != undefined) {
          this.advanced = content.avanzado;
        }

        switch (userLevel) {
          case "basico":
            console.log("this.basic", this.basic);
            this.content_level_data = this.basic;
            break;
          case "intermedio":
            this.content_level_data = this.intermediate;
            break;
          case "avanzado":
            this.content_level_data = this.advanced;
            break;
          default:
            this.content_level_data = this.basic;
            break;
        }
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      }
    },

    async HandlerGetModulePercentage(module_id) {
      try {
        const request = { module_id };
        const response = await this.$store.dispatch(
          "profile/MODULE_PERCENTAGE",
          request
        );
        this.moduleUserPercentage = response.data.data;
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        } else {
          this.$snotify.error(error.response.data.message, "Error!");
        }
      }
    },

    async HandlerGetLevelPercentage(module_id, level) {
      try {
        const request = { module_id, level };
        const response = await this.$store.dispatch(
          "profile/LEVEL_PERCENTAGE",
          request
        );
        this.levelUserPercentage = response.data.data;
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        } else {
          this.$snotify.error(error.response.data.message, "Error!");
        }
      }
    },

    async HandlerGetNotifications() {
      try {
        await this.$store.dispatch("profile/GET_NOTIFICATIONS");
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        } else {
          this.$snotify.error(error.response.data.message, "Error!");
        }
      }
    },

    async HandlerGetAuthUser() {
      try {
        const response = await this.$store.dispatch("auth/ME");
        const company = response.data.data.current_company;
        if (company !== null) {
          this.courseCertificateEnabled = company.course_certificate_enabled;
          this.coursesBadgesEnabled = company.courses_badges_enabled;
        } else {
          this.courseCertificateEnabled = 1;
          this.coursesBadgesEnabled = 1;
        }
      } catch (error) {
        console.log(error);
        if (error.response?.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        } else {
          this.$snotify.error(error.response?.data?.message || "Error al obtener información del usuario", "Error!");
        }
      }
    },

    HandlerOpenCertificate() {
      if (this.certificateUrl) {
        window.open(this.certificateUrl, '_blank');
      }
    },

    HandlerOpenBadge() {
      if (this.badgeUrl) {
        window.open(this.badgeUrl, '_blank');
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .classContainerBodySlot {
    width: 100% !important;
    padding: 1rem !important;
    margin-left: 0 !important;
  }
}

.divider-mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .containerHeaderCourseContent {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 1rem;
  }
  
  .containerHeaderCourseContent .containerBtnsList {
    width: 100%;
    flex-direction: column;
  }
  
  .containerTitleAndLoader {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0.5rem;
    margin-bottom: 15px;
  }
  
  .containerBtnsList {
    width: 100%;
    flex-direction: column;
  }
  
  .containerBtn--seeRigthNow {
    width: 100%;
  }
  
  .divider-mobile-only {
    display: block;
  }
}
.pillsPendingTitle-container {
  margin-left: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pillsPendingTitle {
  text-align: left;
  font: normal normal bold 18px/27px Poppins;

  letter-spacing: 0px;
  color: #101820;
}
.flexDefault3 {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
}
.containerTabs {
  border-radius: 12px;
  /* max-width: 1070px; */
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.containerHeaderCourse {
  margin-bottom: 1rem;
}

.containerHeaderCourseContent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.containerHeaderCourseText {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.spanBolderAdv {
  text-align: left;
  font: normal normal bold 16px/24px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
}
.btn-updatePlan {
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  text-align: center;
  font: normal normal normal 13px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  width: 135px;
  height: 34px;
  display: flex;
  padding: 10.5px 0px;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}
.white-10 {
  background-color: #ffffff20;
}
.circleIcon {
  width: 30px;
  height: 30px;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  /* overflow: hidden; */
  border-radius: 100px;
  padding: 5px;
  justify-content: center;
}
.textPUpdatePlan {
  text-align: left;
  font: normal normal normal 14px/21px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
}
.textTitleUpdatePlan {
  text-align: left;
  font: normal normal 600 22px/40px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  margin: 0.3rem 0;
}
.container-update-plan {
  padding: 1rem;
  top: 516px;
  left: 1132px;
  width: 350px;
  display: flex;
  flex-direction: column;
  height: 325px;
  background: transparent
    linear-gradient(315deg, #febd8e 0%, #eb64d3 49%, #7d8dff 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
}
.iconHeartcolorBorder {
  color: white;
}
.roundHeartIconWraper {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 32px;
  border: 0.5px solid #f9f9f9;
}
.btn-seeRigthNow {
  text-align: center;
  font: normal normal normal 14px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  padding: 5px 24px;
}
.text--5min {
  text-align: left;
  font: normal normal 300 10px/40px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.flexDefault {
  display: flex;
  align-items: center;
  align-items: center;
  gap: 1rem;
}
.flexDefault2 {
  flex: 2;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
}
.text-new-custom {
  text-align: left;
  font: normal normal normal 12px/40px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.container-new-text--new {
  background: #ffffff15 0% 0% no-repeat padding-box;
  border-radius: 6px;
  padding: 0px 9px;
}
.container-new-pill_text-title {
  top: 291px;
  left: 495px;
  text-align: left;
  font: normal normal bold 20px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  margin: 11px 0;
}
.container-new-pill_text {
  top: 360px;
  left: 495px;
  text-align: left;
  font: normal normal 300 14px/21px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.container-new-pill {
  top: 235px;
  left: 465px;
  width: 100%;
  /* height: 262px; */
  padding: 27px;
  display: flex;
  flex-direction: column;
  background: var(--unnamed-color-101820) 0% 0% no-repeat padding-box;
  background: #101820 0% 0% no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
}
.v-progress-circular {
  margin: 1rem;
}

.badge-bg-warning {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  background-color: rgba(255, 193, 7, 1) !important;
  color: 33, 37, 41;
  color: rgba(33, 37, 41, 1) !important;
}

.containerPathGone--loader {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.containerPathGone--loader--titles {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.containerPathGone--loader--titles--yourPath {
  text-align: right;
  font: normal normal normal 12px/18px Poppins;
  letter-spacing: 0px;
  color: #101820;
}

.containerTitleAndButtonsList {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0rem;
}

.containerTitleAndLoader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.containerTitleList {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.subtitleList--text {
  text-align: left;
  font: normal normal 300 12px Poppins;
  letter-spacing: 0px;
  color: #6f7b87;
}

.titleList--text {
  text-align: left;
  font: normal normal bold 17px/23px Poppins;
  letter-spacing: 0px;
  color: #101820;
  padding-bottom: 10px;
}

.containerBtnsList {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.containerBtn--seeRigthNow {
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  text-align: center;
  font: normal normal normal 13px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 9px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  max-height: 48px;
}

.containerBtn--seeRigthNow:disabled {
  background: #0076ff 0% 0% no-repeat padding-box;
  cursor: not-allowed;
  opacity: 0.4;
}

.containerBtn--seeRigthNow:disabled:hover {
  background: #0076ff 0% 0% no-repeat padding-box;
  opacity: 0.4;
}

.course-module-section {
  width: 100%;
  display: grid;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.course-module-section__title {
  margin: 0;
  text-align: left;
  font: normal normal 700 14px/22px Poppins;
  letter-spacing: 0px;
  color: #101820;
}
</style>
